// extracted by mini-css-extract-plugin
export var statItem = "_ib-1";
export var statsRow = "_ib-0";